import React, { PropsWithChildren } from "react";
import AppUpdateListener from "./app-update-listener";
import DateFilterUpdateListener from "./date-filter-update-listener";
import MessageThreadSeenListener from "./message-thread-seen-listener";

const Listeners: React.FC<PropsWithChildren> = () => (
  <>
    <MessageThreadSeenListener />
    <AppUpdateListener />
    <DateFilterUpdateListener />
  </>
);

export default Listeners;
